<template>
    <EpubReader />
</template>

<script setup lang="ts">
import EpubReader from '~/components/pupil/EpubReader.vue';

definePage({
    meta: {
        layout: 'epub-reader',
        area: 'reader',
    },
});
</script>
